<header>
  <div class="header-left">
    <a routerLink="/map" class="app-name">Spotil</a>
  </div>
  <div class="header-center">
    <a routerLink="/map" class="map-btn" title="Map">🗺️</a>
  </div>
  <div class="header-right">
    @if (auth.loggedIn()) {
      <div class="profile-dropdown">
        <button class="profile-btn" (click)="toggleDropdown()">
          @if (auth.userImage()) {
            <img [src]="auth.userImage()" class="avatar-img" alt="avatar" />
          } @else {
            <span class="avatar-placeholder">{{ auth.userName()[0] }}</span>
          }
          <span class="user-name">{{ auth.userName() }}</span>
        </button>
        @if (showDropdown) {
          <div class="dropdown-menu">
            <a routerLink="/profile" (click)="showDropdown = false">Profile</a>
            @if (auth.isAdminOrAbove()) {
              <a routerLink="/admin" (click)="showDropdown = false">Dashboard</a>
            }
            <button (click)="logout()">Logout</button>
          </div>
        }
      </div>
    } @else {
      <a routerLink="/login" class="profile-link">
        <span class="profile-icon">👤</span>
      </a>
    }
  </div>
</header>
